/* eslint @typescript-eslint/strict-boolean-expressions: off */

import cn from "classnames";
import React from "react";
import styles from "gui/grid/cell.module.css";
import { Size } from "gui/theme/theme";

interface CellProps {
  as?: string;
  id?: string;
  className?: string;
  overflowVisible?: boolean;
  scrollable?: boolean;
  "aria-labelledby"?: string;
  style?: React.CSSProperties;
  height?: Size;
  span3?: Size;
  span4?: Size;
  span5?: Size;
  span6?: Size;
  span7?: Size;
  span8?: Size;
  span9?: Size;
}

export const Cell: React.FC<CellProps> = (props) => {
  const as = props.as ?? "div";

  const className = cn(
    styles.cell,
    props.overflowVisible && styles.overflowVisible,
    props.scrollable && styles.scrollable,
    props.height && styles[`height-${props.height}`],
    props.span3 && styles[`span3-${props.span3}`],
    props.span4 && styles[`span4-${props.span4}`],
    props.span5 && styles[`span5-${props.span5}`],
    props.span6 && styles[`span6-${props.span6}`],
    props.span7 && styles[`span7-${props.span7}`],
    props.span8 && styles[`span8-${props.span8}`],
    props.span9 && styles[`span9-${props.span9}`],
    props.className
  );

  const componentProps = {
    className,
    id: props.id,
    style: props.style,
    "aria-labelledby": props["aria-labelledby"],
  };

  return React.createElement(as, componentProps, props.children);
};
